import {Navigate, Outlet, useLocation} from "react-router-dom";
import useAuth from "../services/authentication/useAuth";

export default function Layout() {
    let auth = useAuth();
    let location = useLocation();

    if (!auth.user && (location.pathname === '/' || location.pathname === '')) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (auth.user && location.pathname === '/') {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to="/app" state={{ from: location }} replace />;
    }

    return <main className="App">
        <Outlet/>
    </main>;
}
